import {Component} from 'react';

class Unauthorized extends Component {
  render() {
    return (
      <div>
        <center>
          <h1>ご利用には認証が必要です</h1>
          <p></p>
          <p>
            サブウィンドウで認証を行ってください
            <br />
            ポップアップがブロックされる場合は、ポップアップを許可してから画面を再読み込みしてください
            <br />
            認証完了後も画面が切り替わらない場合は再読み込みしてください
          </p>
          <p>
            <a href="">認証画面を再表示する</a>
          </p>
        </center>
      </div>
    );
  }
}

export default Unauthorized;
